<dx-popup
    #dimensionSelectorPopup
    title="Dimension Selector"
    [showTitle]="true"
    width="30%"
    height="20%"
    [resizeEnabled]="true"
    [visible]="visible"
    (onShown)="onShown()"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col" class="dimension-container">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-form #dimensionSelectorForm width="100%" height="100%" [colCount]="1">
                        <dxi-item itemType="group" [colCount]="1">
                            <dxi-item *ngFor="let dim of requiredDimensions" [isRequired]="dim.required">
                                <dxo-label [text]="dim.text"></dxo-label>
                                <div *dxTemplate>
                                    <dx-select-box
                                        [searchEnabled]="true"
                                        [dataSource]="dim.options"
                                        displayExpr="text"
                                        valueExpr="code"
                                        [showClearButton]="true"
                                        [(value)]="dim.selectedDimension"
                                        (onValueChanged)="onDimChangeClick($event, dim)"
                                    ></dx-select-box>
                                </div>
                            </dxi-item>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    hint="Cancel"
                                    [icon]="iconCancel"
                                    (onClick)="onHidden()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    hint="Select"
                                    text="Select"
                                    [icon]="iconCheck"
                                    (onClick)="onSelectClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
